import React from "react";
import { LineChart } from "../../common/components/charts/line"
import ImpiantiByYearsStore from "../ImpiantiByYearsStore"
import { ChartDataConfig } from "../../common/components/charts/chartsHelper";
import { Loading } from "../../common/components/loading";

export default () => {
    const items = ImpiantiByYearsStore.useAll();
    if (!items)
        return <Loading />

    let years = items.map(x => x.year);
    const data: ChartDataConfig = {
        labels: years.map(x => x.toString()),
        datasets: [{
            description: `Nuovi impianti`,
            values: items.map(x => x.tot),
        }]
    };

    return <LineChart
        key={new Date().valueOf()}
        title="ANDAMENTO NUOVI IMPIANTI ANNUALE"
        data={data}
        hideLegend
        colorscheme={3}
    />
}